module.exports = "<span class=\"success-toast\">\n  <h2 style=\"text-align: center;\">Saved</h2>\n</span>\n"